// Angular + External
import { Injectable, Output, EventEmitter } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
// BFX
import { BfxPrimeService } from "../services/bfx-prime.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class PrimeGuard {
  private config: any = {
    debug: true,
  };

  constructor(private _router: Router, private _primeService: BfxPrimeService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._primeService.isPrimed()) {
      return true;
    } else {
      this._router.navigate(["loading", state.url.slice(1)]);
    }
  }
}
